import axios from 'axios';
import resolvePath from 'utils/resolvePath';
const GET_STRIPE_ENVIRONMENT_API_RELATIVE_PATH = 'environments/show_stripe_public_key';
const GET_PAYPAL_ENVIRONMENT_API_RELATIVE_PATH = 'environments/show_paypal_client_id';
// Action
const GET_ENVIRONMENTS_REQUEST = 'environments/getEnvironmentsRequest';
const GET_ENVIRONMENTS_SUCCESS = 'environments/getEnvironmentsSuccess';
const GET_ENVIRONMENTS_FAILURE = 'environments/getEnvironmentsFailure';
const GET_STRIPE_ENVIRONMENT_REQUEST = 'environments/getStripeEnvironmentRequest';
const GET_STRIPE_ENVIRONMENT_SUCCESS = 'environments/getStripeEnvironmentSuccess';
const GET_STRIPE_ENVIRONMENT_FAILURE = 'environments/getStripeEnvironmentFailure';
const GET_PAYPAL_ENVIRONMENT_REQUEST = 'environments/getPaypalEnvironmentRequest';
const GET_PAYPAL_ENVIRONMENT_SUCCESS = 'environments/getPaypalEnvironmentSuccess';
const GET_PAYPAL_ENVIRONMENT_FAILURE = 'environments/getPaypalEnvironmentFailure';
// Action Creator
export const getEnvironmentsRequest = () => {
    return {
        type: GET_ENVIRONMENTS_REQUEST,
    };
};
export const getEnvironmentsSuccess = (environments) => {
    return {
        payload: {
            environments,
        },
        type: GET_ENVIRONMENTS_SUCCESS,
    };
};
export const getEnvironmentsFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_ENVIRONMENTS_FAILURE,
    };
};
export const getEnvironments = () => (dispatch) => {
    dispatch(getEnvironmentsRequest());
    return axios
        .get(resolvePath.api('environments'))
        .then((response) => dispatch(getEnvironmentsSuccess(response.data)))
        .catch((error) => {
        dispatch(getEnvironmentsFailure(error));
        throw error;
    });
};
export const getStripeEnvironmentRequest = () => {
    return {
        type: GET_STRIPE_ENVIRONMENT_REQUEST,
    };
};
export const getStripeEnvironmentSuccess = (stripeEnvironments) => {
    return {
        payload: {
            stripeEnvironments,
        },
        type: GET_STRIPE_ENVIRONMENT_SUCCESS,
    };
};
export const getStripeEnvironmentFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_STRIPE_ENVIRONMENT_FAILURE,
    };
};
export const getStripeEnvironments = () => (dispatch) => {
    dispatch(getStripeEnvironmentRequest());
    return axios
        .get(resolvePath.api(GET_STRIPE_ENVIRONMENT_API_RELATIVE_PATH))
        .then((response) => dispatch(getStripeEnvironmentSuccess(response.data)))
        .catch((error) => {
        dispatch(getStripeEnvironmentFailure(error));
        throw error;
    });
};
export const getPaypalEnvironmentRequest = () => {
    return {
        type: GET_PAYPAL_ENVIRONMENT_REQUEST,
    };
};
export const getPaypalEnvironmentSuccess = (paypalEnvironments) => {
    return {
        payload: {
            paypalEnvironments,
        },
        type: GET_PAYPAL_ENVIRONMENT_SUCCESS,
    };
};
export const getPaypalEnvironmentFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_PAYPAL_ENVIRONMENT_FAILURE,
    };
};
export const getPaypalEnvironments = () => (dispatch) => {
    dispatch(getPaypalEnvironmentRequest());
    return axios
        .get(resolvePath.api(GET_PAYPAL_ENVIRONMENT_API_RELATIVE_PATH))
        .then((response) => dispatch(getPaypalEnvironmentSuccess(response.data)))
        .catch((error) => {
        dispatch(getPaypalEnvironmentFailure(error));
        throw error;
    });
};
const initialState = {
    environments: {
        app_socket_url: '',
    },
    stripeEnvironments: {
        public_key: '',
    },
    paypalEnvironments: {
        paypal_client_id: '',
    },
    error: null,
    isFetching: false,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ENVIRONMENTS_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_ENVIRONMENTS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { environments: Object.assign({}, action.payload.environments), isFetching: false });
        }
        case GET_ENVIRONMENTS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case GET_STRIPE_ENVIRONMENT_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_STRIPE_ENVIRONMENT_SUCCESS: {
            return Object.assign(Object.assign({}, state), { stripeEnvironments: Object.assign({}, action.payload.stripeEnvironments), isFetching: false });
        }
        case GET_STRIPE_ENVIRONMENT_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case GET_PAYPAL_ENVIRONMENT_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_PAYPAL_ENVIRONMENT_SUCCESS: {
            return Object.assign(Object.assign({}, state), { paypalEnvironments: Object.assign({}, action.payload.paypalEnvironments), isFetching: false });
        }
        case GET_PAYPAL_ENVIRONMENT_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        default: {
            return state;
        }
    }
};
